import { Form, Input, Row } from 'antd';
import { FormInput } from '@gtintel/platform-atoms';
function UserProfileTextFields({
  handleFormState,
  first_name,
  last_name,
  phone,
  alter_phone,
  email,
  company,
  street_address,
  apartment,
  biography
}) {
  return <>
      <Row className="form-row">
        <FormInput handleFormState={handleFormState} label="First name" name="first_name" required={true} value={first_name} testid="first-name-input" />
        <FormInput handleFormState={handleFormState} label="Surname" name="last_name" required={true} value={last_name} testid="surname-input" />
      </Row>
      <Row className="form-row">
        <FormInput handleFormState={handleFormState} label="Mobile phone" name="phone" required={false} value={phone} testid="phone-input" disabledMessage="This is used for two-factor authentication. Please contact support if you want to change it." />
        <FormInput handleFormState={handleFormState} label="Alternate Phone" name="alter_phone" required={false} value={alter_phone} testid="alternate-phone-input" />
      </Row>
      <Row className="form-row">
        <FormInput handleFormState={handleFormState} label="Email" name="email" required={true} value={email} testid="email-input" disabledMessage="Please contact support to change your email address." />
        <FormInput handleFormState={handleFormState} label="Company" name="company" required={false} value={company} testid="company-input" />
      </Row>
      <Row className="form-row">
        <FormInput handleFormState={handleFormState} label="Street Address" name="street_address" required={false} value={street_address} testid="street-input" />
        <FormInput handleFormState={handleFormState} label="Apartment/Unit No." name="apartment" required={false} value={apartment} testid="street-number-input" />
      </Row>
      <Form.Item label="Biography" name="biography">
        <Input.TextArea data-testid="biography-input" name="biography" value={biography} autoSize={{
        minRows: 2
      }} onChange={e => handleFormState('biography', e.target.value)} />
      </Form.Item>
    </>;
}
export default UserProfileTextFields;